import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
export const OptionsList = ({ options, className }) => {
    const { OptionsList: theme } = useTheme('InsurancePage');
    return (React.createElement("ul", { className: cn(theme.list, className) }, options.map(option => (React.createElement("li", { key: option, dangerouslySetInnerHTML: { __html: option } })))));
};
